import {
  HOME_PATH,
  NUTRITION_PATH,
  HEALTH_PATH,
  SHOP_PATH,
  ACCOUNT_MANAGEMENT_PATH,
} from '@/constants/paths';
import { ShopIcon } from '@/components/icons/ShopIcon';
import { HomeIcon } from '@/components/icons/HomeIcon';
import { HealthIcon } from '@/components/icons/HealthIcon';
import { ProfileIcon } from '@/components/icons/ProfileIcon';
import { NutritionIcon } from '@/components/icons/NutritionIcon';
import { ShopFilledIcon } from '@/components/icons/ShopFilledIcon';
import { HomeFilledIcon } from '@/components/icons/HomeFilledIcon';
import { HealthFilledIcon } from '@/components/icons/HealthFilledIcon';
import { ProfileFilledIcon } from '@/components/icons/ProfileFilledIcon';
import { NutritionFilledIcon } from '@/components/icons/NutritionFilledIcon';

export const DASHBOARD_ROUTES = [
  {
    to: HOME_PATH,
    label: 'Home',
    icon: HomeIcon,
    activeIcon: HomeFilledIcon,
    hideIconForCancerDetect: false,
    hideIconForDisabledFormulaRecs: false,
  },
  {
    to: HEALTH_PATH,
    label: 'Health',
    icon: HealthIcon,
    activeIcon: HealthFilledIcon,
    hideIconForCancerDetect: true,
    hideIconForDisabledFormulaRecs: false,
  },
  {
    to: NUTRITION_PATH,
    label: 'Nutrition',
    icon: NutritionIcon,
    activeIcon: NutritionFilledIcon,
    hideIconForCancerDetect: true,
    hideIconForDisabledFormulaRecs: false,
  },
  {
    to: SHOP_PATH,
    label: 'Shop',
    icon: ShopIcon,
    activeIcon: ShopFilledIcon,
    hideIconForCancerDetect: false,
    hideIconForDisabledFormulaRecs: true,
  },
  {
    to: ACCOUNT_MANAGEMENT_PATH,
    label: 'Profile',
    icon: ProfileIcon,
    activeIcon: ProfileFilledIcon,
    hideIconForCancerDetect: false,
    hideIconForDisabledFormulaRecs: false,
  },
] as const;
